import { ProductDoc, PromotionSectionItem } from '@gooduncles/gu-app-schema';
import { Button, notification } from 'antd';
import { FC, useCallback, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { updateDocWithCollection } from 'src/utils/firebase/firebase-short-cut';

const DeletePromotionSectionItemRenderer: FC<{
  productId: ProductDoc['_id'];
  promotionId: string;
  items: PromotionSectionItem[];
  collection: string;
}> = ({ productId, promotionId, items, collection }) => {
  const [loading, setLoading] = useState(false);

  const onDelete = useCallback(async () => {
    setLoading(true);
    try {
      const newItems = items
        .filter((item) => item.id !== productId)
        .sort((a, b) => a.index - b.index)
        .map((item, idx) => ({ ...item, index: idx + 1 }));
      await updateDocWithCollection(collection, promotionId, {
        items: newItems,
      });
      notification.success({ message: '프로모션에서 상품을 삭제했습니다.' });
    } catch (error) {
      console.error(error);
      const description = errorObjectToString(error);
      notification.error({ message: '프로모션에서 상품 삭제 실패', description });
    }
    setLoading(false);
  }, [productId, items, promotionId, collection]);

  if (!productId || !promotionId) return null;

  return (
    <Button danger onClick={onDelete} loading={loading}>
      삭제
    </Button>
  );
};

export default DeletePromotionSectionItemRenderer;
